
//Scoring into a dom by id
export const scrollingById = (id) => {
	const anchorScroll = document.getElementById(id);
	if (anchorScroll) {
		const scrollTop = document.documentElement.scrollTop | document.body.scrollTop;
		const clientTop = anchorScroll.getBoundingClientRect().top;
		window.scrollTo(0, scrollTop + clientTop);
	}
};
export const getCookie = (cname) => {
	var name = cname + '=';
	var decodedCookie = decodeURI(document.cookie);
	var ca = decodedCookie.split(';');
	for (var i = 0; i < ca.length; i++) {
		var c = ca[i];
		while (c.charAt(0) === ' ') {
			c = c.substring(1);
		}
		if (c.indexOf(name) === 0) {
			return c.substring(name.length, c.length);
		}
	}
	return '';
};

export const setCookie = (cname, cvalue, exdays) => {
	var d = new Date();
	d.setTime(d.getTime() + (exdays * 60 * 1000));
	var expires = 'expires=' + d.toUTCString();
	document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
};
